/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

const __unstableBlockNameContext = createContext( '' );
__unstableBlockNameContext.displayName = '__unstableBlockNameContext';

export default __unstableBlockNameContext;
